import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-print-internet',
  templateUrl: './page-print-internet.component.html',
  styleUrls: ['./page-print-internet.component.css']
})
export class PagePrintInternetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
